import { TOOLTIP_OFFSET } from 'src/plugins/helpers/tooltip-defaults'

// The dialer button's look: red while the dialer has an error, solid Talk blue while open, light blue at rest
export function dialerButtonClass ({ errorCode, isOpen }) {
  if (errorCode) {
    return 'is-error'
  }

  return isOpen ? 'is-open' : ''
}

// The banner's icon for each diagnosis type the status endpoint sends
const BANNER_ICONS = {
  warning: 'triangle-alert',
  '10dlc-warning': 'triangle-alert',
  danger: 'circle-alert',
  info: 'info',
  success: 'circle-check'
}

export function bannerIcon (type) {
  return BANNER_ICONS[type] ?? 'info'
}

// A header control's tooltip offset that opens it the tooltip gap below the header's bottom edge
export function headerTooltipOffset (headerRect, controlRect, gap = TOOLTIP_OFFSET[1]) {
  return [0, Math.max(0, Math.round(headerRect.bottom - controlRect.bottom)) + gap]
}

// Header dropdowns open 8px below their control, as in Admin's header. A fixed gap, not a measured one: a menu
// measured as it opens is placed, then moved.
export const HEADER_MENU_GAP = 8
export const HEADER_MENU_OFFSET = [0, HEADER_MENU_GAP]
